<script setup lang="ts">
import type { UserColor } from '@cockpit/shared';
import { computed } from 'vue';

const props = defineProps<{ initials: string; color: UserColor; small?: boolean }>();
const style = computed(() => ({ '--pc': `var(--${props.color})` }));
</script>

<template>
  <span class="av" :class="{ sm: small }" :style="style" aria-hidden="true">{{ initials }}</span>
</template>
